<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem; margin-bottom: 0!important;">
		<div class="py-2 border-bottom d-flex align-items-center">
			<el-button type="primary" size="mini" icon="el-icon-search">查看本机是否安装控件</el-button>
			<el-button type="primary" size="mini" icon="el-icon-search">获取打印机列表</el-button>
			<el-button type="success" size="mini" icon="el-icon-search">打印预览</el-button>
			<el-button type="success" size="mini" icon="el-icon-search">直接打印</el-button>
			<el-button type="success" size="mini" icon="el-icon-search">选择打印机打印</el-button>
		</div>
		<div>
			<el-table :data="tableData" style="width: 100%" highlight-current-row @current-change="handleCurrentChange" size="mini">
				<el-table-column width="220">
					<template slot="header" slot-scope="scope">打印机名称</template>
					<template slot-scope="scope">{{scope.row.name}}</template>
				</el-table-column>
				<el-table-column width="240">
					<template slot="header" slot-scope="scope">驱动名称</template>
					<template slot-scope="scope">{{scope.row.qd}}</template>
				</el-table-column>
				<el-table-column width="140">
					<template slot="header" slot-scope="scope">端口名称</template>
					<template slot-scope="scope">{{scope.row.dk}}</template>
				</el-table-column>
				<el-table-column width="140" align="center">
					<template slot="header" slot-scope="scope">打印方向</template>
					<template slot-scope="scope">{{scope.row.fx}}</template>
				</el-table-column>
				<el-table-column width="150" align="center">
					<template slot="header" slot-scope="scope">纸张大小（编号）</template>
					<template slot-scope="scope">{{scope.row.dxid}}</template>
				</el-table-column>
				<el-table-column width="178" align="center">
					<template slot="header" slot-scope="scope">纸张长度/0.1mm</template>
					<template slot-scope="scope">{{scope.row.cd}}</template>
				</el-table-column>
				<el-table-column width="178" align="center">
					<template slot="header" slot-scope="scope">纸张宽度/0.1mm</template>
					<template slot-scope="scope">{{scope.row.kd}}</template>
				</el-table-column>
			</el-table>
		</div>
		
		<el-dialog title="类别详情" :visible.sync="createModel" top="15vh">
			<!-- 表单内容 -->
			<div style="width: 100%;margin-top: 20px;">
				<el-form :rules="rules" ref="form" :model="form" label-width="80px">
					<el-form-item label="信息编号">
						<el-input v-model="form.id" size="mini" style="width: 95%;"></el-input>
					</el-form-item>
					<el-form-item label="名称">
						<el-input v-model="form.name" placeholder="名称" size="mini" style="width: 95%;"></el-input>
					</el-form-item>
					<el-form-item label="创建人">
						<el-button type="primary" size="mini">{{form.user}}</el-button>
					</el-form-item>
					<el-form-item label="备注">
						<el-input v-model="form.desc" placeholder="备注" size="mini" style="width: 95%;"></el-input>
					</el-form-item>
					<el-form-item label="资金账号">
						<el-input v-model="form.zh" size="mini" style="width: 95%;"></el-input>
					</el-form-item>
					<el-form-item label="创建时间">
						<el-input v-model="form.create_time" size="mini" style="width: 95%;"></el-input>
					</el-form-item>
				</el-form>
			</div>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit(tableData)">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import buttonSearch from '@/components/common/button-search.vue'; // 引入 按钮、搜索、高级搜索组件
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	// 引入注册
	components: {
		buttonSearch
	},
	data() {
		return {
			num:994,
			rules: {

			},
			form: {
				id:10,
				create_time: '2022-08-19 14:40:20',
				name: '银行【对公】',
				class:1,
				user:'你好啊',
				state:1,
				desc:'',
				zh:'6666644448'
			},
			createModel: false,
			currentRow: null,
			tableData: [
				{
					id:1,
					name: 'Microsoft XPS Document Writer',
					qd:'Microsoft XPS Document Writer v4',
					dk:'PORTPROMPT:',
					fx:1,
					dxid:9,
					cd:2970,
					kd:2100
				},{
					id:2,
					name: 'Microsoft Print to PDF',
					qd:'Microsoft Print To PDF',
					dk:'PORTPROMPT:',
					fx:1,
					dxid:9,
					cd:2970,
					kd:2100
				},{
					id:3,
					name: 'HP DeskJet 2300 series',
					qd:'HP DJ 2300 series PCL-3',
					dk:'USB001',
					fx:1,
					dxid:9,
					cd:2970,
					kd:2100
				},{
					id:4,
					name: 'Fax',
					qd:'Microsoft Shared Fax Driver',
					dk:'SHRFAX:',
					fx:1,
					dxid:9,
					cd:2970,
					kd:2100
				}
			],
		};
	},

	methods: {
		handleChange(value){},
		openModel(e = false) {
			console.log(e)
			this.tableData[e.row.id-1] = {
				id:e.row.id,
				create_time: '2022-08-19 14:40:20',
				name: e.row.name,
				class:e.row.class,
				state:1,
				user:'你好啊'
			};
			// 打开dialog
			this.createModel = true;
		},
		submit(e) {
			console.log(e)
			// this.tableData.push(e)
			this.createModel = false;
			// this.$refs.form.validate(res => {
			// 	if (res) {
			// 		console.log(res)
			// 		// 关闭模态框
			// 		this.createModel = false;
			// 	}
			// });
		},
		handleCurrentChange(val) {
		    this.currentRow = val;
		},
	}
};
</script>

<style></style>
